import {
  Grid,
  IconButton,
  Typography,
  useMediaQuery,
  useTheme,
  Collapse,
  Box,
  Checkbox,
} from "@material-ui/core";
import { Block, Save, KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import GlobitsDateTimePicker from "app/common/form/GlobitsDateTimePicker";
import GlobitsPagingAutocomplete from "app/common/form/GlobitsPagingAutocomplete";
import GlobitsTextField from "app/common/form/GlobitsTextField";
import GlobitsVNDCurrencyInput from "app/common/form/GlobitsVNDCurrencyInput";
import GlobitsNumberInput from "app/common/form/GlobitsNumberInput";
import GlobitsCheckBox from "app/common/form/GlobitsCheckBox";
import useDefaultDepartment from "app/common/hooks/useDefaultDepartment";
import IconDelete from "app/common/Icon/IconDelete";
import {
  LEAD_SOURCE_LEVEL,
  PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT,
  PAYMENT_METHOD_CHARACTERISTIC_POS,
  PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP,
  PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT,
} from "app/common/LocalConst";
import {
  getPositionCodes,
  getDate,
  formatMoney,
  validateSelectDiffirentTelesale,
  validateSelectTelesale,
  validateMaxTotalAmountTelesale,
  validateMaxTotalDiffTelesale,
  validateEqualsSourceDiffirentTelesale,
  transformDate
} from "app/common/LocalFunction";

import { pagingDepartment } from "app/services/DepartmentService";
import { pagingStaff } from "app/services/StaffService";
import { pagingPosition } from "app/services/PositionService";
import { pagingCustomerSource } from "app/services/CustomerSourceService";
import { useStore } from "app/stores";
import { FieldArray, getIn, useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { forwardRef, memo } from "react";
import * as Yup from "yup";
import { renderOptionsStaff } from "app/PatientManagement/ReportSalesAllocation/ReportSalesAllocationSearch";
import TotalOfVoucherTypeRefund from "../Component/TotalOfVoucherTypeRefund";
import { ArrowDownward } from "@material-ui/icons";

const RefundDepositPopup = ({ open, handleClose, initialData, handleSubmit }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const defaultDepartment = useDefaultDepartment();
  const { handleGetPatientOverviewByIdNotLoading } =
    useStore().patientManagementStore.patientGeneralStore;

  const validationSchema = Yup.object().shape({
    department: Yup.object().nullable().required("Chưa chọn cơ sở!"),
    accountant: Yup.object().nullable().required("Chưa chọn người hoàn!"),
    voucherDate: Yup.date()
      .transform(transformDate)
      .typeError("Ngày hoàn chưa đúng định dạng!")
      .nullable()
      .required("Bạn chưa chọn ngày lập!"),
    items: Yup.array().of(
      Yup.object().shape({
        refundAmount: Yup.number()
          .min(0, "Số tiền hoàn không được âm")
          .test(
            "max-refund",
            "Số tiền hoàn không được vượt quá số tiền còn lại",
            function (value) {
              const { amount, refundedAmount } = this.parent;
              const remaining = (amount || 0) - (refundedAmount || 0);
              return (value || 0) <= remaining;
            }
          )
          .test(
            "date-check",
            "Ngày hoàn phải lớn hơn hoặc bằng ngày cọc",
            function (value) {
              const { voucherDate: depositDate, checked } = this.parent;
              const globalDate = this.options.from[1].value.voucherDate;
              if (checked && value > 0 && depositDate && globalDate) {
                const depTime = new Date(depositDate).setHours(0, 0, 0, 0);
                const refTime = new Date(globalDate).setHours(0, 0, 0, 0);
                return refTime >= depTime;
              }
              return true;
            }
          ),
        staffRevenues: Yup.array()
          .of(
            Yup.object().shape({
              position: Yup.object().nullable().required("Bắt buộc nhập chức danh"),
              staff: Yup.object().nullable().required("Phải chọn Nhân viên!"),
              source: Yup.object().required("Bắt buộc nhập nguồn phân bổ").nullable(),
              percentRevenue: Yup.number()
                .nullable()
                .min(0, "Tối thiểu 0%")
                .max(100, "Tối đa 100%"),
            })
          )
          .test(
            "at-least-one-diffirent-sale",
            "Cần chọn phân bổ cho người tư vấn !",
            function(value) {
                if (this.parent.refundAmount > 0) {
                    return validateSelectDiffirentTelesale(value);
                }
                return true;
            }
          )
          .test(
            "at-least-one-sale",
            "Cần chọn phân bổ cho telesale!",
            function(value) {
                if (this.parent.refundAmount > 0) {
                    return validateSelectTelesale(value);
                }
                return true;
            }
          )
          .test(
            "max-total-amount-telesale",
            "Tổng phân bổ telesale phải bằng 100%",
            function(value) {
                if (this.parent.refundAmount > 0) {
                    return validateMaxTotalAmountTelesale(value);
                }
                return true;
            }
          )
          .test(
            "max-total-amount-consultant",
            "Tổng phân bổ tư vấn viên và kĩ thuật viên phải bằng 100%",
            function(value) {
                if (this.parent.refundAmount > 0) {
                    return validateMaxTotalDiffTelesale(value);
                }
                return true;
            }
          )
          .test(
            "equals-source-revenue-sale-diffirent",
            "Tổng phân bổ telesale phải bằng các chức danh khác trong cùng nguồn!",
            function(value) {
                if (this.parent.refundAmount > 0) {
                    return validateEqualsSourceDiffirentTelesale(value);
                }
                return true;
            }
          )
          .nullable(),
        voucherPaymentMethods: Yup.array().of(
          Yup.object().shape({
            totalOfMethod: Yup.number().nullable(),
            paymentBank: Yup.object().nullable().when(["totalOfMethod", "paymentMethodValue"], {
              is: (totalOff, method) => (totalOff !== 0) && (
                method?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT ||
                method?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS ||
                method?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP ||
                method?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT
              ),
              then: (schema) => schema.required("Bắt buộc nhập"),
            }),
          })
        ).nullable(),
      }).nullable()
    ).test(
        "at-least-one-checked",
        "Vui lòng chọn ít nhất 1 mục để hoàn tiền!",
        function(value) {
            return (value || []).some(it => it.checked);
        }
    ).test(
        "total-not-exceed-available",
        "Tổng tiền hoàn không được vượt quá số dư tiền cọc còn lại!",
        function(items) {
            const { depositAvailable } = this.parent;
            const totalRefund = (items || []).filter(it => it.checked).reduce((acc, it) => acc + (Number(it.refundAmount) || 0), 0);
            return totalRefund <= (depositAvailable || 0) + 1; // permit small roundings
        }
    ),
    voucherPaymentMethods: Yup.array()
      .of(
        Yup.object().shape({
          totalOfMethod: Yup.number().nullable(),
          paymentBank: Yup.object().nullable().when(["totalOfMethod", "paymentMethodValue"], {
            is: (totalOff, method) => (totalOff !== 0) && (
              method?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_REQUIRES_BANK_ACCOUNT ||
              method?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS ||
              method?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_POS_VNPAY_TRAGOP ||
              method?.characteristic === PAYMENT_METHOD_CHARACTERISTIC_HOME_CREDIT
            ),
            then: (schema) => schema.required("Bắt buộc nhập"),
          }),
        })
      )
      .test(
        "total-matches-refund",
        "Tổng tiền trong HTTT phải bằng tổng số tiền hoàn!",
        function(value) {
            const { items } = this.parent;
            const totalRefund = (items || []).filter(it => it.checked).reduce((acc, it) => acc + (Number(it.refundAmount) || 0), 0);
            const totalHTTT = (value || []).reduce((acc, pm) => acc + (Number(pm.totalOfMethod) || 0), 0);
            return Math.abs(totalRefund - totalHTTT) < 1; // Cho phép sai số nhỏ do làm tròn
        }
      )
  });

  return (
    <PopupForm
      open={open}
      size="xl"
      handleClose={handleClose}
      title={"Hoàn tiền cọc"}
      formik={{
        initialValues: {
          ...initialData,
          department: defaultDepartment,
        },
        onSubmit: async (values, formikHelpers) => {
          await handleSubmit(values, formikHelpers);
          await handleGetPatientOverviewByIdNotLoading(values?.patient?.id);
        },
        enableReinitialize: true,
        validationSchema: validationSchema,
      }}
      action={({ isSubmitting }) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" disabled={isSubmitting}>
              {!isMobile && <Save className="mr-2 " />}
              Hoàn cọc
            </CommonButton>
            <CommonButton className="btn-gray" onClick={handleClose}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ values, setFieldValue }) => {
        return (
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <Grid container spacing={1} style={{ backgroundColor: "aliceblue", padding: "10px", borderRadius: "4px" }}>
                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsPagingAutocomplete
                    name={"department"}
                    label={"Cơ sở"}
                    api={pagingDepartment}
                    required
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsPagingAutocomplete
                    label="Người hoàn"
                    name="accountant"
                    displayLabel="staffName"
                    api={pagingStaff}
                    required
                    searchObject={{ isActive: true }}
                    renderOption={(option) => renderOptionsStaff(option)}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsDateTimePicker
                    required
                    label="Ngày hoàn"
                    name="voucherDate"
                    isDateTimePicker
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={3}>
                  <GlobitsTextField
                    isTextArea
                    rows={1}
                    label="Lý do / Nội dung"
                    name="note"
                  />
                </Grid>

                 <Grid item xs={12} sm={6} md={3}>
                    <GlobitsVNDCurrencyInput
                      disabled
                      label="Tiền cọc còn lại"
                      name="depositAvailable"
                    />
                 </Grid>
               </Grid>
            </Grid>

            


            <Grid item xs={12} md={8}>
              <Typography variant="h6" gutterBottom>
                Danh sách tiền cọc có thể hoàn
              </Typography>
              <div className="table-root mt-2">
                <table className="table-container">
                   <thead>
                    <tr className="row-table-header">
                      <th width="3%">
                        <Checkbox
                          color="primary"
                          indeterminate={
                            values.items.some((it) => it.checked) &&
                            !values.items.every((it) => it.checked)
                          }
                          checked={
                            values.items.length > 0 &&
                            values.items.every((it) => it.checked)
                          }
                          onChange={(e) => {
                            const checked = e.target.checked;
                            const newItems = values.items.map((it) => {
                              return {
                                ...it,
                                checked: checked,
                                refundAmount: 0,
                                staffRevenues: (it.staffRevenues || []).map((sr) => ({
                                  ...sr,
                                  actualAmount: 0,
                                })),
                              };
                            });
                            setFieldValue("items", newItems);
                          }}
                        />
                      </th>
                      <th width="10%">Ngày cọc</th>
                      <th width="12%">Mã phiếu</th>
                      <th width="15%">Số tiền cọc</th>
                      <th width="12%">Đã hoàn</th>
                      <th width="20%">Số tiền hoàn</th>
                    </tr>
                  </thead>
                  <FieldArray name="items">
                    {() => (
                      <tbody>
                        {values.items.map((item, index) => (
                          <ItemRow key={index} item={item} index={index} initialData={initialData} />
                        ))}
                      </tbody>
                    )}
                  </FieldArray>
                </table>
              </div>
            </Grid>

            <Grid item xs={12} md={4}>
              <div className="p-2" style={{ backgroundColor: "#f8f9fa", borderRadius: "4px", border: "1px solid #ddd" }}>
                 <h4 className="mb-2" style={{ color: "#4276a4" }}>Hình thức hoàn tiền</h4>
                 <TotalOfVoucherTypeRefund
                    listPaymentMethod={initialData?.listPaymentMethod}
                    listStk={initialData?.listStk}
                    listPos={initialData?.listPos}
                    listHomecredit={initialData?.listHomecredit}
                    listPos_tragop={initialData?.listPos_tragop}
                    moneyAfterDiscount={(values.items || []).filter(it => it.checked).reduce((acc, it) => acc + (it.refundAmount || 0), 0)}
                    nameSpace={`voucherPaymentMethods`}
                 />
              </div>
            </Grid>
          </Grid>
        );
      }}
    </PopupForm>
  );
};

const ItemRow = observer(({ item, index, initialData }) => {
  const { values, setFieldValue } = useFormikContext();

  return (
    <>
      <tr>
        <td align="center">
          <Checkbox
            color="primary"
            name={`items[${index}].checked`}
            checked={item.checked}
            onChange={(e) => {
              const checked = e.target.checked;
              setFieldValue(`items[${index}].checked`, checked);
              setFieldValue(`items[${index}].refundAmount`, 0);
              const staffRevenues = (item.staffRevenues || []).map((sr) => ({
                ...sr,
                actualAmount: 0,
              }));
              setFieldValue(`items[${index}].staffRevenues`, staffRevenues);
            }}
          />
        </td>

        <td align="center">{getDate(item?.voucherDate)}</td>
        <td align="center">{item?.voucherCode || ""}</td>
        <td align="right">{formatMoney(item?.amount)}</td>
        <td align="right">{formatMoney(item?.refundedAmount || 0)}</td>
        <td>
          <GlobitsVNDCurrencyInput
            disabled={!item.checked}
            name={`items[${index}].refundAmount`}
            onChange={(e) => {
              const val = +e.target.value;
              const max = (item.amount || 0) - (item.refundedAmount || 0);
              const actualVal = val > max ? max : val;
              setFieldValue(`items[${index}].refundAmount`, actualVal);
              
              const staffRevenues = (item.staffRevenues || []).map((sr) => ({
                ...sr,
                actualAmount: (actualVal * (sr.percentRevenue || 0)) / 100,
              }));
              setFieldValue(`items[${index}].staffRevenues`, staffRevenues);
            }}
          />
        </td>

      </tr>
      <tr>
        <td colSpan={6} style={{ background: "#f8f9fa", padding: "16px" }}>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <div style={{ paddingRight: "16px" }}>
                  <h4 className="mb-2" style={{ color: "#4276a4" }}>Phân bổ doanh thu nhân viên</h4>
                  <StaffRevenues itemIndex={index} />
              </div>
            </Grid>
          </Grid>
        </td>
      </tr>
    </>
  );
});

const StaffRevenues = observer(({ itemIndex }) => {
  const { values, setFieldValue } = useFormikContext();
  const { EXCLUDE_QUIT_STAFF } = useStore().appConfigStore || {};
  const POSITION_CODES = getPositionCodes();
  const item = values.items[itemIndex];
  const staffRevenues = item.staffRevenues || [];

  return (
    <FieldArray name={`items[${itemIndex}].staffRevenues`}>
      {({ remove, push }) => (
        <Grid container spacing={1}>
          <Grid item xs={12} sm={3}>
            <GlobitsPagingAutocomplete
              label={"Nguồn"}
              name={`items[${itemIndex}].sourceRevenue`}
              api={pagingCustomerSource}
              searchObject={{ level: LEAD_SOURCE_LEVEL.LEVEL_2.value }}
            />
          </Grid>
          <Grid item xs={12} sm={3}>
            <GlobitsPagingAutocomplete
              label={"Chọn chức danh"}
              name={`items[${itemIndex}].position`}
              api={pagingPosition}
              searchObject={{
                isUsing: true,
                positionCodes: POSITION_CODES,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={5}>
            <GlobitsPagingAutocomplete
              disableClearable
              label={"Chọn nhân viên"}
              api={pagingStaff}
              name={`items[${itemIndex}].staff`}
              displayLabel="staffName"
              autoUpercase
              searchObject={{
                positionId: values.items[itemIndex]?.position?.id,
                isActive: true,
                excludeStatus: EXCLUDE_QUIT_STAFF,
              }}
              renderOption={(option) => renderOptionsStaff(option)}
            />
          </Grid>
          <Grid item xs={1} className="flex align-end">
            <CommonButton
               className="btn-primary"
               onClick={() => {
                const source = values.items[itemIndex]?.sourceRevenue;
                const position = values.items[itemIndex]?.position;
                const staff = values.items[itemIndex]?.staff;
                if (!staff) return;
                
                push({
                  staff: staff,
                  source: source,
                  position: position || staff?.position,
                  percentRevenue: 100,
                  actualAmount: item.refundAmount || 0,
                });
                setFieldValue(`items[${itemIndex}].staff`, null);
              }}
            >
              <ArrowDownward />
            </CommonButton>
          </Grid>

          <Grid item xs={12}>
            <div className="table-root mt-2">
              <div style={{ maxHeight: "300px", overflow: "auto" }}>
                <table className="table-container" style={{ width: "100%", backgroundColor: "white" }}>
                  <thead>
                    <tr className="row-table-header" style={{ backgroundColor: "#e8ecef" }}>
                      <th width="5%">STT</th>
                      <th width="20%">Nguồn</th>
                      <th width="25%">Chức danh</th>
                      <th width="25%">Nhân viên</th>
                      <th width="10%">%</th>
                      <th width="10%">Tiền</th>
                      <th width="5%"></th>
                    </tr>
                  </thead>
                  <tbody>
                    {staffRevenues.map((sr, srIndex) => (
                      <tr key={srIndex}>
                        <td align="center">{srIndex + 1}</td>
                        <td>
                          <GlobitsPagingAutocomplete
                            api={pagingCustomerSource}
                            name={`items[${itemIndex}].staffRevenues[${srIndex}].source`}
                            searchObject={{
                              level: LEAD_SOURCE_LEVEL.LEVEL_2.value,
                              departmentId: values.department?.id,
                            }}
                          />
                        </td>
                        <td>
                          <GlobitsPagingAutocomplete
                            api={pagingPosition}
                            name={`items[${itemIndex}].staffRevenues[${srIndex}].position`}
                            searchObject={{
                              isUsing: true,
                              positionCodes: POSITION_CODES,
                            }}
                            onChange={(_, value) => {
                              setFieldValue(`items[${itemIndex}].staffRevenues[${srIndex}].position`, value);
                              setFieldValue(`items[${itemIndex}].staffRevenues[${srIndex}].staff`, null);
                            }}
                          />
                        </td>
                        <td>
                          <GlobitsPagingAutocomplete
                            api={pagingStaff}
                            name={`items[${itemIndex}].staffRevenues[${srIndex}].staff`}
                            displayLabel={"staffName"}
                            searchObject={{
                              positionId: sr.position?.id,
                              isActive: true,
                            }}
                            renderOption={(option) => renderOptionsStaff(option)}
                          />
                        </td>
                        <td>
                          <GlobitsNumberInput
                            name={`items[${itemIndex}].staffRevenues[${srIndex}].percentRevenue`}
                            onChange={(e) => {
                              const percentRevenue = +e?.target?.value;
                              setFieldValue(`items[${itemIndex}].staffRevenues[${srIndex}].percentRevenue`, percentRevenue);
                              setFieldValue(`items[${itemIndex}].staffRevenues[${srIndex}].actualAmount`, (percentRevenue * item.refundAmount) / 100);
                            }}
                          />
                        </td>
                        <td>
                          <GlobitsVNDCurrencyInput
                            name={`items[${itemIndex}].staffRevenues[${srIndex}].actualAmount`}
                            onChange={(e) => {
                              const val = e.target.value;
                              setFieldValue(`items[${itemIndex}].staffRevenues[${srIndex}].actualAmount`, val);
                              if (item.refundAmount > 0) {
                                 setFieldValue(`items[${itemIndex}].staffRevenues[${srIndex}].percentRevenue`, (val / item.refundAmount) * 100);
                              }
                            }}
                          />
                        </td>
                        <td align="center">
                          <IconButton size="small" onClick={() => remove(srIndex)}>
                            <IconDelete />
                          </IconButton>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </Grid>
        </Grid>
      )}
    </FieldArray>
  );
});

export default observer(RefundDepositPopup);
